import React from "react"
import { Platform } from "~/ui/primitives"
import { InputTextFloatLabel } from "~components/input-text"
import { rules } from "~utils/validator"

const isIOS = Platform.OS === "ios"
interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const Email: React.FC<Props> = ({ value, onChange, ...rest }) => (
  <InputTextFloatLabel
    label="邮箱"
    keyboardType={isIOS ? "ascii-capable" : "visible-password"}
    placeholder="请输入邮箱"
    value={value}
    onChangeText={onChange}
    validRule={rules.email}
    {...rest}
  />
)

export default Email
